import { ActGlo, ActVote } from '../App_Data/ActionTypes';

const initialState = {
    NumReuSel: 0,
    Votant: ActGlo.EN_COURS_DE_CHARGEMENT,
};

function VoteStore(state = initialState, action) {
    switch (action.type) {
    case ActGlo.RESET_STORE:
    case ActVote.VOTES_CHOIX:
        return {
            ...state,
            NumReuSel: action.data,
        };
    case ActVote.VOTES_RECUP:
        return {
            ...state,
            Votant: action.data,
        };
    case ActVote.VOTES_MAJ:
        return {
            state
            // ...state,
            // Votes: state.Votes.map(vote => (vote.Id === action.data.Id ? { ...vote, ...action.data } : vote)),
        };
    default:
        return state;
    }
}

export default VoteStore;



// WEBPACK FOOTER //
// ./src/Reducers/VoteStore.js